import * as React from 'react';
import { IBarcodeService } from '../abstraction';

interface IProps {
	barcodeService: IBarcodeService;
}

interface IState {
	dotVisible: boolean;
	barCodeAwaitingCalls: number;
	isActive: boolean;
}

// Barre de status située en bas de l'écran affichant l'état de l'application  (rond clignotant)
//
export class KBarCodeStatus extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			dotVisible: true,
			barCodeAwaitingCalls: 0,
			isActive: true,
		}

		this.props.barcodeService.AliveSignal.add((data) => {
			this.setState({
				dotVisible: !this.state.dotVisible,
				barCodeAwaitingCalls: data.awaitingScans,
				isActive: data.isActive
			});
		});
	}

	//#region React Hacks

	// Pour éviter un warning sur la console JS du navigateur, on se désabonne de l'évènement
	componentWillUnmount = () => {
		this.props.barcodeService.AliveSignal.reset();
	}

	//#endregion React Hacks

	render() {
		let inactiv = !this.state.isActive ? " inactive " : "";
		let dot = !this.state.isActive ? " inactive " : this.state.dotVisible ? "" : "hide";
		return (
			<div className={"KBarCodeStatus " + inactiv} onClick={() => { this.props.barcodeService.StartStop(); }}>
				<span className={"dot " + dot}></span>
				<span className="content" >{this.state.barCodeAwaitingCalls}</span>
			</div>
		);
	}
}

